import { render, staticRenderFns } from "./paid-popup.vue?vue&type=template&id=712a692c&scoped=true"
import script from "./paid-popup.vue?vue&type=script&lang=js"
export * from "./paid-popup.vue?vue&type=script&lang=js"
import style0 from "./paid-popup.vue?vue&type=style&index=0&id=712a692c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712a692c",
  null
  
)

export default component.exports